
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"22","cy":"5","r":"5","fill":"#000"}}),_c('circle',{attrs:{"cx":"15.026","cy":"11.95","r":"4.5","fill":"#fff"}}),_c('circle',{attrs:{"cx":"15.538","cy":"14","r":"4","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.638 6a5.1 5.1 0 102.151 9.724 5.977 5.977 0 01-.231-1.23 3.886 3.886 0 01-1.92.506 3.9 3.9 0 113.66-5.246 6.03 6.03 0 01.972-.787A5.098 5.098 0 007.638 6z","fill":"#000"}}),_c('path',{attrs:{"d":"M22.09 26h-13a.484.484 0 01-.485-.55c.495-3.376 2.238-4.93 3.24-5.375a.457.457 0 01.38.016c2.914 1.375 5.47.673 6.595.042a.52.52 0 01.456-.038c2.71 1.154 3.321 3.873 3.29 5.459a.464.464 0 01-.476.446z","stroke":"#000","stroke-width":"1.2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.686 9.388a5.1 5.1 0 113.903 9.423 5.1 5.1 0 01-3.903-9.423zm1.952.812a3.9 3.9 0 100 7.8 3.9 3.9 0 000-7.8z","fill":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.481 16.548a1.057 1.057 0 00-.88-.021c-1.21.537-3.069 2.28-3.59 5.836a1.084 1.084 0 001.08 1.237h5.902c.126-.428.27-.827.43-1.2H1.22c.48-3.008 1.995-4.35 2.798-4.743 3.08 1.431 5.805.714 7.073.012.388.17.727.377 1.023.612.761.346 1.485.577 2.165.718a5.667 5.667 0 00-2.768-2.456 1.12 1.12 0 00-.985.067c-.985.553-3.335 1.217-6.045-.062z","fill":"#000"}}),_c('path',{attrs:{"d":"M22 2v6M19 5h6","stroke":"#fff","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    